import AvatarPortalDemoPoster from "../../../../../images/posters/avatar/walkthroughs/portal-walkthrough.webp";
import AvatarAppWalkthroughPoster from "../../../../../images/posters/avatar/walkthroughs/app-walkthrough.webp";

const avatarWalkthroughs = [
  {
    "title": "Avatar Nutrition Portal Walkthrough",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Nutrition+Portal+Demo+2026.mp4",
    "thumbnail": AvatarPortalDemoPoster,
    "length": "40:57",
    "starred": true,
    "timestamps": [
      {
        "title": "0:00 - Intro",
        "time": 0
      },
      {
        "title": "0:20 - Coaching Overview",
        "time": 20
      },
      {
        "title": "5:21 - Inspect Account",
        "time": 321
      },
      {
        "title": "8:45 - Edit Account",
        "time": 525
      },
      {
        "title": "11:30 - Practice Mode/Pause your Goal",
        "time": 690
      },
      {
        "title": "14:32 - Meal Planning",
        "time": 872
      },
      {
        "title": "16:04 - Messaging",
        "time": 964
      },
      {
        "title": "17:10 - Groups",
        "time": 1030
      },
      {
        "title": "18:21 - Campaigns",
        "time": 1101
      },
      {
        "title": "20:19 - Check-in Forms",
        "time": 1219
      },
      {
        "title": "28:10 - Team Management",
        "time": 1690
      },
      {
        "title": "30:11 - Client Management",
        "time": 1811
      },
      {
        "title": "32:05 - Billing",
        "time": 1925
      },
      {
        "title": "33:43 - Adding You & Your Team As Clients (Friends Feature)",
        "time": 2023
      },
      {
        "title": "40:40 - Conclusion",
        "time": 2440
      }
    ]
  },
  {
    "title": "Avatar Nutrition App Walkthrough",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+App+Walkthrough+2026.mp4",
    "thumbnail": AvatarAppWalkthroughPoster,
    "length": "15:26",
    "starred": true,
    "objectFit": "contain",
    "timestamps": [
      {
        "title": "0:00 - Intro",
        "time": 0
      },
      {
        "title": "0:22 - How to use Avatar",
        "time": 22
      },
      {
        "title": "0:43 - Features that help you hit your macros",
        "time": 43
      },
      {
        "title": "1:23 - Daily macro adjustments",
        "time": 83
      },
      {
        "title": "1:52 - Edit balance tool (carb/fat swap)",
        "time": 112
      },
      {
        "title": "2:32 - Adding food",
        "time": 152
      },
      {
        "title": "3:15 - Favorite items, meals, & days",
        "time": 195
      },
      {
        "title": "3:37 - Recipes",
        "time": 217
      },
      {
        "title": "3:55 - Preview macros",
        "time": 235
      },
      {
        "title": "4:18 - Recipe ingredient swaps",
        "time": 258
      },
      {
        "title": "4:46 - Recent items",
        "time": 286
      },
      {
        "title": "5:06 - Meal Plan",
        "time": 306
      },
      {
        "title": "6:26 - Tracking alcohol",
        "time": 386
      },
      {
        "title": "6:47 - Multi-selecting items",
        "time": 407
      },
      {
        "title": "7:05 - Copying meals & days",
        "time": 425
      },
      {
        "title": "7:34 - Sharing food with friends",
        "time": 454
      },
      {
        "title": "8:38 - Drag & drop food",
        "time": 518
      },
      {
        "title": "8:56 - Check-ins",
        "time": 536
      },
      {
        "title": "10:18 - Macro adjustments",
        "time": 618
      },
      {
        "title": "10:40 - Check-in history",
        "time": 640
      },
      {
        "title": "10:58 - Editing a check-in",
        "time": 658
      },
      {
        "title": "11:17 - Progress photos",
        "time": 677
      },
      {
        "title": "11:42 - Coaching",
        "time": 702
      },
      {
        "title": "12:01 - Additional features",
        "time": 721
      },
      {
        "title": "12:06 - Edit macros & calories",
        "time": 726
      },
      {
        "title": "12:16 - Edit activity level",
        "time": 736
      },
      {
        "title": "12:48 - Advanced features",
        "time": 768
      },
      {
        "title": "12:52 - High/low days",
        "time": 772
      },
      {
        "title": "12:57 - Pause your goal",
        "time": 777
      },
            {
        "title": "13:09 - Practice mode",
        "time": 789
      },
      {
        "title": "13:25 - Daily weights",
        "time": 805
      },
      {
        "title": "13:33 - Intermittent fasting",
        "time": 813
      },
      {
        "title": "14:30 - Body measurements",
        "time": 870
      }
    ]
  }
];

export default avatarWalkthroughs; 
